// src/hooks/useLPData.js

import { useState, useEffect, useCallback } from 'react';
import web3Service from '../Services/web3Services';
import { CONTRACTS } from '../utils/constants';
import lpPairABI from '../Contracts/lpPairABI.json';

const useLPData = () => {
  const [lpContract, setLpContract] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // LP Data
  const [data, setData] = useState({
    token0: null,
    token1: null,
    reserve0: null,
    reserve1: null,
    totalSupply: null
  });

  // Initialize LP contract - runs ONCE
  useEffect(() => {
    console.log('🔵 useLPData: Initializing...');
    
    try {
      const lp = web3Service.getContract(lpPairABI, CONTRACTS.LP_PAIR);
      
      if (lp) {
        setLpContract(lp);
        console.log('✅ LP contract created:', CONTRACTS.LP_PAIR);
      } else {
        throw new Error('Failed to create LP contract');
      }
    } catch (err) {
      console.error('❌ useLPData error:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []); // Empty deps = runs ONCE

  // Fetch LP data - runs when contract is ready
  useEffect(() => {
    if (!lpContract) return;

    const fetchLPData = async () => {
      console.log('🔵 Fetching LP data...');
      
      try {
        const [token0, token1, reserves, totalSupply] = await Promise.all([
          web3Service.call(lpContract, 'token0'),
          web3Service.call(lpContract, 'token1'),
          web3Service.call(lpContract, 'getReserves'),
          web3Service.call(lpContract, 'totalSupply')
        ]);


        setData({
          token0,
          token1,
          reserve0: reserves[0],
          reserve1: reserves[1],
          totalSupply
        });
      } catch (err) {
        console.error('❌ Error fetching LP data:', err);
        setError(err.message);
      }
    };

    fetchLPData();
  }, [lpContract]); // Runs when contract is ready

  // Refresh function (for later use)
  const refresh = useCallback(() => {
    console.log('🔄 LP refresh called (no-op for now)');
  }, []);

  return {
    lpContract,
    contractAddress: CONTRACTS.LP_PAIR,
    isLoading,
    error,
    hasContract: !!lpContract,
    data,
    refresh
  };
};

export default useLPData;